import React from 'react';
import { compose } from 'redux';
import AdminTemplate from 'components/templates/Admin';
import HeaderContainer from 'containers/HeaderContainer';
import DynamicProfileViewContainer from 'containers/DynamicProfileViewContainer';
import ProtectedRoute from 'hoc/ProtectedRoute';
import SideBarContainer from 'containers/SideBarContainer';
import TitleContainer from 'containers/TitleContainer';
import { AdminBreadcrumb, AdminBreadcrumbItem } from 'components/atoms/AdminBreadcrumb';
import PageTitle from 'hoc/PageTitle';
import { SideBarObjects } from 'components/pages/config/AdminSideBarObjects';
import { ADMINAREA_ACCESS, DYNAMIC_PROFILE_READ } from 'constants/capabilities';

const ViewDynamicProfilePage = props => (
    <AdminTemplate
        header={<HeaderContainer admin />}
        sidebar={<SideBarContainer navItems={SideBarObjects} />}
        title={<TitleContainer
            title={(
                <AdminBreadcrumb>
                    <AdminBreadcrumbItem to="/admin/dynamic-profiles">&lt; Dynamic Profiles</AdminBreadcrumbItem>
                </AdminBreadcrumb>)}
            admin hideDatePicker />}>

        <DynamicProfileViewContainer {...props} />
    </AdminTemplate>
);

export default compose(
    PageTitle({ pageTitle: 'View Dynamic Profile', showGGBranding: true }),
    ProtectedRoute({ requiredCapabilities: [ADMINAREA_ACCESS, DYNAMIC_PROFILE_READ] }),
)(ViewDynamicProfilePage);



// WEBPACK FOOTER //
// ./src/components/pages/admin/dynamicProfiles/ViewDynamicProfile.js